<template>
    <div class="dv5-my-stuff-tool-card">
        <div class="my-stuff-tool-card-header">
            <div class="my-stuff-tool-card-title">{{camelize(view.name)}}</div>
        </div>
        <div class="my-stuff-tool-card-content">
            <div class="my-stuff-tool-card-img-tool">
                <img  :src="getImagePath(view.tools_id)" >
            </div>

            <div class="my-stuff-tool-card-subtitle">{{camelize(subtitle)}}</div>
        </div>
        <div class="my-stuff-tool-card-footer">
<!--            <div class="my-stuff-tool-card-url"-->
<!--            >{{view.url}}</div>-->
<!--            &lt;!&ndash; botao &ndash;&gt;-->
<!--            <div>{{camelize(view.additional_info.title)}}</div>-->
<!--        v-if="view.url !== undefined && view.url !== null"  -->
            <div
                class="my-stuff-tool-card-button"
                @click="redirect(view.url, view.tools_id)"
            >{{ !IsEmpty(view.buttonText) ? view.buttonText : t.va_access  }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dv5-my-stuff-tool-card',
    props: {
        view: {
            type: Object,
            default: function() {
                return {
                    name: 'TITULO',
                    tools_id: -1,
                    url: '#',
                    buttonText: 'teste',
                    src: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-default.svg',
                    additional_info: {
                        title: "Subtitulo qualquer"
                    }
                }
            }
        },
        available_tools: {
            type: Array
        },
        handler_routes: {
            type: Object
        },
        getToolByIntelligenceId: {
            type: Function
        },
        t: {
            type: Array|Object
        }
    },
    data: function() {
        return {
          t: null
        }
    },
    created() {
      this.t = this.props.t
    },
    methods: {
        redirect(link, tool_id){

            var tool = this.getToolByIntelligenceId(tool_id);

            if(!tool) { return; }

            var toolName = tool.name;

            // workaround with 'super_checkout' and 'blog_builder' is a not standalone tool
            if(['super_checkout','blog_builder'].includes(toolName)) { toolName = 'cheetah_builder'; }

            // if not has tool access, redirect to upgrade
            if(!this.available_tools.includes(toolName)) { return window.open(`${this.handler_routes.rota_office_upgrade}?tool=${toolName}`, '_blank'); }

            var window_auth = window.open(tool.access_url, '_blank'),
                redirect_timeout = 5400;

            if(['super_checkout'].includes(tool.name)) {
                redirect_timeout = 1;
            }

            if(link !== undefined && link !== null) {
                setTimeout(function(){  window_auth.location.href = link;  }, redirect_timeout);
            }
        },
        camelize(str = ''){
            return str.split(/[\-\_\s]/).map((word) => {
                return word.substr(0, 1).toUpperCase() + word.substr(1)
            }).join(' ')
        },
        getImagePath(tool_id){
            var iconPath    = '/internacional/public/office5/img/tools/default/',
                tool        = this.getToolByIntelligenceId(tool_id),
                defaultIcon = 'default.svg';

            if(!tool_id || !tool) {
                return iconPath + defaultIcon;
            }

            return iconPath + tool.icon;
        },
        IsEmpty(val) {
          return isEmpty(val);
        }
    },
    computed: {
        subtitle: function() {

            if(this.view.additional_info !== undefined && this.view.additional_info != null) {

                // additional_info.title
                if(this.view.additional_info.hasOwnProperty('title') && this.view.additional_info.title !== undefined && this.view.additional_info.title != null) {
                    return this.view.additional_info.title;
                }

                // additional_info.name
                if(this.view.additional_info.hasOwnProperty('name') && this.view.additional_info.name !== undefined && this.view.additional_info.name != null) {
                    return this.view.additional_info.name;
                }

                // additional_info.name
                if(this.view.additional_info.hasOwnProperty('product') && this.view.additional_info.product !== undefined && this.view.additional_info.product != null) {
                    return this.view.additional_info.product;
                }
            }

            // tool name
            return this.view.name;
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../../scss/extras/_variables';

    .dv5-my-stuff-tool-card {
        font-family: "Muli";
        font-size: 10px; // base to em
        line-height: 1.2;


        background-color: $dv5-color4;
        border-radius: 0.4em;

        min-height: 10em; // 100px
        width: 100%;
        height: 43.4em; // 434px

        display: flex;
        flex-direction: column;
        justify-content: stretch;

        .my-stuff-tool-card-header{
            //border: solid 1px red;
            font: inherit;
            height: 10em; // 100px

            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .my-stuff-tool-card-title{
                font: inherit;
                font-family: "Lato" !important;
                font-size: 2.4em; // 24px
                font-weight: 900;
                color: $dv5-color1;
            }
        }

        .my-stuff-tool-card-content{
            //border: solid 1px green;
            font: inherit;
            height: 23.4em; // 234px
            background-color: #fcfcfc;
            -webkit-box-shadow: 0 0px 0 1px #dfe7f2;
            -moz-box-shadow: 0 0px 0 1px #dfe7f2;
            box-shadow: 0 0px 0 1px #dfe7f2;


            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;

            .my-stuff-tool-card-img-tool{
                display: flex;
                justify-content: center;
                align-items: stretch;
                img{
                    width: 10.15625vw; // 195px  - image has box shadow
                    min-width: 130px;
                    height: auto;
                }
            }
            .my-stuff-tool-card-subtitle{
                font: inherit;
                font-size: 1.7em;
                font-weight: 600;
                color: $dv5-color1;
                margin-bottom: .5em;
                text-align: center;
                padding: 0 5px;
                margin-top: -12px;
            }
        }

        .my-stuff-tool-card-footer{
            //border: solid 1px blue;
            font: inherit;
            height: 10em; // 100px

            display: flex;
            align-items: center;
            justify-content: space-evenly;
            flex-direction: column;

            .my-stuff-tool-card-button{
                font: inherit;
                font-size: 1.4em;
                font-weight: 900;
                text-transform: uppercase;
                text-align: center;

                border-radius: 0.5em;
                background-color: $dv5-color1;
                color: $dv5-color4;

                padding: 0.75em 1em;
                //margin: 0 0 3% 0;
                width: 47%;
                // height: 50%;

                display: flex;
                flex-direction: column;
                justify-content: center;
                word-break: break-word;
                word-wrap: break-word;

                &:hover{
                    cursor: pointer;
                    box-shadow: 0 0 0.5em -0.14286em $dv5-color1;
                }
            }
        }
    }

    @media screen and (max-width: 1199px) {
        .dv5-my-stuff-tool-card {
            font-size: 8px;
        }
    }
    @media screen and (max-height: 2300px) {
        .my-stuff-tool-card-img-tool {
            margin-top: -20px !important;
        }
    }

    //.dv5-my-stuff-tool-card{
    // .my-stuff-tool-card-img{
    //     font: inherit;
    //     max-width: 100%;
    //     width: 100%;
    //     height: auto;v-if="view.additional_info !== undefined && view.additional_info !== null"
    //     border-radius: 4px;
    //     margin-bottom: 1.5em;
    // }
    // .my-stuff-tool-card-subtitle-link{
    //     font: inherit;
    //     font-size: 1.4em;
    //     color: #3091f2;
    //     margin-bottom: 1em;
    //     &:hover,
    //     &:hover i,
    //     &:hover i::before,
    //     &:hover i::after{
    //         cursor: pointer;
    //         color: $dv5-color1;
    //     }
    // }
    //}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/my-stuff/MyStuffToolCard.vue